import React, { useRef, useEffect } from 'react';
import { MdEdit, MdQuestionAnswer } from 'react-icons/md';

const SelectionPopup = ({ 
  showPopup, 
  setShowPopup, 
  popupPosition, 
  selectedText, 
  onEditDocument,
  onEditQuestions 
}) => {
  const popupRef = useRef(null);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };

    if (showPopup) {
      window.document.addEventListener('mousedown', handleClickOutside);
      return () => window.document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showPopup, setShowPopup]);

  if (!showPopup) return null;

  return (
    <div
      ref={popupRef}
      className="fixed z-50 bg-white border border-gray-200/60 rounded-xl shadow-xl overflow-hidden backdrop-blur-sm"
      style={{
        left: popupPosition.x,
        top: popupPosition.y,
        minWidth: '200px',
        maxWidth: '280px'
      }}
    >
      {/* Selected text preview */}
      <div className="px-4 py-3 bg-gray-50/50 border-b border-gray-200/60">
        <div className="text-xs text-gray-500 mb-1.5 font-medium">Selected text</div>
        <div className="text-sm text-gray-700 max-h-16 overflow-y-auto font-mono text-xs leading-relaxed">
          {selectedText.length > 100 ? selectedText.substring(0, 100) + '...' : selectedText}
        </div>
      </div>
      
      {/* Action buttons */}
      <div className="flex">
        <button
          onClick={onEditDocument}
          className="flex-1 flex items-center justify-center px-4 py-3.5 text-sm font-medium hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200 border-r border-gray-200/60"
        >
          <MdEdit className="mr-2" size={16} />
          <span>Edit Document</span>
        </button>
        
        <button
          onClick={onEditQuestions}
          className="flex-1 flex items-center justify-center px-4 py-3.5 text-sm font-medium hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
        >
          <MdQuestionAnswer className="mr-2" size={16} />
          <span>Edit Questions</span>
        </button>
      </div>
    </div>
  );
};

export default SelectionPopup;